/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API - V2 Redesigned
 * Redesigned API endpoints (v2) for better performance with smaller, functional DTOs. Each endpoint provides only the data needed for specific UI components/tabs.  V2 endpoints are designed to replace heavy monolithic v1 endpoints: - Reduced response sizes by 80-95% - Component-specific data loading - Pagination and filtering support - Optimized for mobile and slow connections 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserTeamReference } from './UserTeamReference';
import {
    UserTeamReferenceFromJSON,
    UserTeamReferenceFromJSONTyped,
    UserTeamReferenceToJSON,
    UserTeamReferenceToJSONTyped,
} from './UserTeamReference';
import type { UserTournamentReference } from './UserTournamentReference';
import {
    UserTournamentReferenceFromJSON,
    UserTournamentReferenceFromJSONTyped,
    UserTournamentReferenceToJSON,
    UserTournamentReferenceToJSONTyped,
} from './UserTournamentReference';

/**
 * User-specific statistics for personalized dashboard
 * @export
 * @interface UserDashboardStats
 */
export interface UserDashboardStats {
    /**
     * Tournaments created by this user with basic info
     * @type {Array<UserTournamentReference>}
     * @memberof UserDashboardStats
     */
    tournamentsCreated?: Array<UserTournamentReference>;
    /**
     * Teams registered by this user with tournament context
     * @type {Array<UserTeamReference>}
     * @memberof UserDashboardStats
     */
    teamsRegistered?: Array<UserTeamReference>;
    /**
     * Total tournaments created by user
     * @type {number}
     * @memberof UserDashboardStats
     */
    tournamentsCount?: number;
    /**
     * Total teams registered by user
     * @type {number}
     * @memberof UserDashboardStats
     */
    teamsCount?: number;
    /**
     * Total matches user's teams participated in
     * @type {number}
     * @memberof UserDashboardStats
     */
    matchesCount?: number;
}

/**
 * Check if a given object implements the UserDashboardStats interface.
 */
export function instanceOfUserDashboardStats(value: object): value is UserDashboardStats {
    return true;
}

export function UserDashboardStatsFromJSON(json: any): UserDashboardStats {
    return UserDashboardStatsFromJSONTyped(json, false);
}

export function UserDashboardStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDashboardStats {
    if (json == null) {
        return json;
    }
    return {
        
        'tournamentsCreated': json['tournaments_created'] == null ? undefined : ((json['tournaments_created'] as Array<any>).map(UserTournamentReferenceFromJSON)),
        'teamsRegistered': json['teams_registered'] == null ? undefined : ((json['teams_registered'] as Array<any>).map(UserTeamReferenceFromJSON)),
        'tournamentsCount': json['tournaments_count'] == null ? undefined : json['tournaments_count'],
        'teamsCount': json['teams_count'] == null ? undefined : json['teams_count'],
        'matchesCount': json['matches_count'] == null ? undefined : json['matches_count'],
    };
}

export function UserDashboardStatsToJSON(json: any): UserDashboardStats {
    return UserDashboardStatsToJSONTyped(json, false);
}

export function UserDashboardStatsToJSONTyped(value?: UserDashboardStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournaments_created': value['tournamentsCreated'] == null ? undefined : ((value['tournamentsCreated'] as Array<any>).map(UserTournamentReferenceToJSON)),
        'teams_registered': value['teamsRegistered'] == null ? undefined : ((value['teamsRegistered'] as Array<any>).map(UserTeamReferenceToJSON)),
        'tournaments_count': value['tournamentsCount'],
        'teams_count': value['teamsCount'],
        'matches_count': value['matchesCount'],
    };
}

